import { AutoComplete, AutoCompleteProps } from 'antd'
import cx from 'classnames'
import { FC, memo } from 'react'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'
import { ReactComponent as ErrorIcon } from '../../assets/icons/error.svg'
import { formFieldID } from '../../utils/helpers'

interface IAutoCompleteField extends Omit<AutoCompleteProps, 'onChange' | 'onSelect'> {
	label?: string
	input: Partial<WrappedFieldInputProps>
	meta: Partial<WrappedFieldMetaProps>
	inputClassName?: string
	onValueChange?: (value: string) => void
	onOptionSelect?: (value: string, option: any) => void
}

const AutoCompleteField: FC<IAutoCompleteField> = ({
	label,
	placeholder,
	className,
	style,
	input,
	meta,
	inputClassName,
	onValueChange,
	onOptionSelect,
	...props
}) => {
	const { name = 'field', value = undefined } = input
	const { form = 'form', error = undefined, touched = false } = meta

	const id = formFieldID(form, name)

	return (
		<div className={cx('form-field', className)} style={style}>
			{label && (
				<label htmlFor={id} className={'form-field-label'}>
					{label}
				</label>
			)}
			<div className={cx('form-field-item', { error: error && touched })}>
				<AutoComplete
					id={id}
					placeholder={placeholder}
					value={value || undefined}
					onChange={(val) => onValueChange?.(val as string)}
					onSelect={onOptionSelect}
					className={cx(inputClassName, { error: error && touched })}
					style={{ width: '100%' }}
					{...props}
				/>
				<span className={'form-field-item-suffix'}>{error && touched && <ErrorIcon />}</span>
			</div>
			{error && touched && <span className={'form-field-message'}>{error}</span>}
		</div>
	)
}

export default memo(AutoCompleteField)
